import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutSingleGen } from '../layoutSingle';
import { OptsSingle } from '../optsSingle';
import { genSingle } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';

/**
 * Pisemka (Practice Worksheet)
 *
 * Layout: Practice problems arranged in columns.
 * Generates content on-the-fly to fill entire first page, then stops.
 *
 * Migrated from C# EduFrame.Single.Generators.Pisemka
 */
export class Pisemka implements ILayoutSingleGen {
  public async generate(pdf: PdfGen, opts: OptsSingle): Promise<void> {
    const margin = PdfUnit.FromMillimeters(15);
    const lineHeight = PdfUnit.FromMillimeters(10);

    const font = new PdfFont(PdfFont.FONT_NAME, 12);
    const idFont = new PdfFont(PdfFont.FONT_NAME, 8);
    const headFont = new PdfFont(PdfFont.FONT_NAME, 36);
    const top = PdfUnit.FromMillimeters(40);

    const {lang} = opts.data;
    const headerText = (lang && lang.Pisemka_Header) ?? 'Příklady';

    const page = pdf.addPage();

    page.drawString(
      headerText,
      headFont,
      PdfBrush.Black,
      null,
      new PdfRect(margin, top - lineHeight, 200, lineHeight),
      ETextAlign.BottomLeft
    );

    const pageHeight = PdfSize.A4.height;
    const cols = 4;
    const colWidth = (PdfSize.A4.width - 2 * margin) / cols;
    const usableHeight = pageHeight - margin - top;
    const rowsPerPage = Math.floor(usableHeight / lineHeight);
    const itemsPerPage = cols * rowsPerPage;

    let itemIndex = 0;
    let y = top;

    while (y + lineHeight <= pageHeight - margin) {
      for (let col = 0; col < cols; col++) {
        const gen = genSingle(opts.data, opts.generator, 1, false, false)[0];
        const x = margin + col * colWidth;
        const p = new PdfPoint(x, y);
        page.drawString(
          gen.texts[0],
          font,
          PdfBrush.Black,
          null,
          new PdfRect(p.x, p.y, colWidth, lineHeight),
          ETextAlign.TopLeft
        );
      }
      y += lineHeight;
      itemIndex++;
    }
  }
}
